import { Carousel } from "react-responsive-carousel";
import PropTypes from "prop-types";
import React, { Component } from "react";

const defaultProps = {
  showStatus: false,
  showThumbs: false,
  showIndicators: false,
  infiniteLoop: false,
  interval: 5000,
};

const SlideIndicator = ({ isSelected, clickHandler, index }) => (
  <li
    onClick={clickHandler}
    className={`dot ${isSelected ? "selected" : ""}`}
    value={`${index}`}
    role="button"
    aria-selected={isSelected ? "true" : "false"}
    aria-current={isSelected ? "true" : "false"}
    tabIndex={isSelected ? "0" : "-1"}
    aria-label={`go to slide ${index + 1}`}
  ></li>
);

class CarouselWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autoPlay: true,
      lazyLoad: true,
      selectedItem: 0,
      slides: [],
      transitionTime: 50,
    };
  }

  onChange = (index) => {
    if (this.state.lazyLoad) {
      this.setState({
        lazyLoad: false,
        slides: this.duplicateFirstSlide(this.props.slides),
      });
    }
    clearTimeout(this.timeout);
    clearTimeout(this.innerTimeout);
    const maxIndex = this.props.slides.length;
    //make it look like scrolling in one direction
    //todo find a way to get rid of this hack
    if (index === maxIndex) {
      this.timeout = setTimeout(() => {
        this.setState({ transitionTime: 0 }, () => {
          this.setState({ selectedItem: 0 }, () => {
            this.innerTimeout = setTimeout(() => {
              this.setState({ transitionTime: 50 });
            }, 0);
          });
        });
      }, 350);
    } else {
      this.setState({ selectedItem: index });
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ slides: this.lazyLoadSlides(nextProps.slides) });
  }

  duplicateFirstSlide = (slides) => {
    return slides && slides.length > 1
      ? slides.slice().concat(slides[0])
      : slides;
  };

  lazyLoadSlides = (slides) => {
    if (!this.state.lazyLoad) return this.duplicateFirstSlide(slides);
    let start = 0;
    return this.duplicateFirstSlide(
      slides.map((slide, index) => {
        start++;
        if (start <= 2) {
          return slide;
        } else {
          return <div key={index}></div>;
        }
      })
    );
  };

  componentDidMount() {
    this.setState({ slides: this.lazyLoadSlides(this.props.slides) });
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    clearTimeout(this.innerTimeout);
  }

  addAdditionalPropsToSlide = (item, { isSelected }) => {
    if (item.type !== "div") {
      return React.cloneElement(item, { isSelected: isSelected });
    } else {
      return item;
    }
  };

  renderIndicator = (clickHandler, isSelected, index) => {
    return (
      <SlideIndicator
        key={index}
        clickHandler={clickHandler}
        isSelected={isSelected}
        index={index}
      />
    );
  };

  render() {
    const props = Object.assign({}, defaultProps, this.props.customProps);
    return (
      <section aria-label="carousel">
        <div
          className={this.state.slides.length <= 1 ? "hide-arrows" : ""}
          ref={(node) => (this._slider = node)}
        >
          {this.state.slides.length > 0 ? (
            <Carousel
              {...props}
              onChange={this.onChange}
              renderIndicator={this.renderIndicator}
              renderItem={this.addAdditionalPropsToSlide}
              autoPlay={
                this.props.autoPlayOverride ? false : this.state.autoPlay
              }
              transitionTime={this.state.transitionTime}
              selectedItem={this.state.selectedItem}
            >
              {this.state.slides}
            </Carousel>
          ) : null}
        </div>
      </section>
    );
  }
}

CarouselWrapper.propTypes = {
  customProps: PropTypes.object,
  slides: PropTypes.array.isRequired,
};

export default CarouselWrapper;



// WEBPACK FOOTER //
// ./src/components/shared/carousel-wrapper.js